import { render } from "./PdfFile.vue?vue&type=template&id=7ad5f038"
import script from "./PdfFile.vue?vue&type=script&lang=js"
export * from "./PdfFile.vue?vue&type=script&lang=js"
script.render = render

export default script